import React, { useState } from 'react';
import Dropzone from 'react-dropzone';
import cn from 'classnames';

import InputWrapper, { getWrapperProps } from 'components/layout/InputWrapper';
import { notifyDanger } from 'components/layout/Toasts';

import style from './FileDropzone.module.scss';

const FileDropzone = (props) => {
  const { onChange, value, accept, extraError, ...rest } = props;
  const wrapperProps = getWrapperProps(props);

  const [showError, setShowError] = useState(false);
  const handleClearFile = () => onChange(null);

  const handleDrop = (files) => {
    if (files?.length > 0) {
      const file = files[0];

      const acceptedFormats = accept?.split(',').map((format) => format.replace('.', '').trim());
      const isFormatCorrect = accept
        ? files.every((file) => {
            const fileName = file.name;
            const fileExtension = fileName.toLowerCase().split('.').pop();
            return acceptedFormats.includes(fileExtension);
          })
        : true;

      if (!isFormatCorrect) {
        notifyDanger(['Niedozwolony typ pliku.']);
        return;
      }

      onChange(file);
    }
  };

  return (
    <InputWrapper
      {...wrapperProps}
      setShowError={setShowError}
      showError={showError}
    >
      <Dropzone onDrop={handleDrop}>
        {({ getRootProps, getInputProps }) => (
          <section className={cn(style.container, { [style.withFile]: value })}>
            <div {...getRootProps({ className: cn(style.dropzone, { [style.error]: showError }) })}>
              <input
                {...getInputProps()}
                {...rest}
              />
              <p className={style.label}>Przeciągnij i upuść lub kliknij, aby wybrać plik</p>
            </div>
          </section>
        )}
      </Dropzone>
    </InputWrapper>
  );
};

export default FileDropzone;
